import isRequestSignatureSignPopup from './isRequestSignatureSignPopup';

/**
 * When the signature popup is filled with a signature image, the popup dimensions are altered to
 * fit the image inside the request-signature field and maintain the image aspect ratio.  When we
 * do this, the original request-signature field dimensions are stored under requestSettings.  This
 * function is used to retrieve the original dimensions if they've been stored in requestSettings,
 * or the normal dimensions otherwise.
 * @param popup the popup data structure
 * @returns {{width, aspectRatio, height})
 */
const getOriginalSignFieldDimensions = (popup) => {
  if (isRequestSignatureSignPopup(popup)) {
    const requestSettings = popup.requestSettings || {};
    const height = (requestSettings.height || popup.height);
    const width = (requestSettings.width || popup.width);
    return {
      aspectRatio: width / height,
      height,
      width,
    };
  }
  return {
    aspectRatio: (popup.width / popup.height),
    height: popup.height,
    width: popup.width,
  };
};

export default getOriginalSignFieldDimensions;



// WEBPACK FOOTER //
// ./src-react/Popups/helpers/getOriginalSignFieldDimensions.jsx